/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
import * as types from '@/lib/definition/types'
import moment from "moment-timezone";
moment.locale('ja')
import { Octokit } from "@octokit/core";
import { Endpoints } from "@octokit/types";

export interface ProjectReportState {
  [key: string]: any;
}

const ProjectReport = defineModule({
  state: (): ProjectReportState => {
    return {
    }
  },
  getters: {
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    }
  },
  actions: {
    async getMyProjects(context): Promise<Array<types.ProjectReportProject>> {
      const { rootState, commit } = moduleActionContext(context, ProjectReport)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<Array<types.ProjectReportProject>>>('/api/projectreport/myprojects', "プロジェクトリストの取得に失敗しました", {}, rootState.Login.accessToken)
      var list = retval.data.data
      return list
    },
    async getProjectReport(context, payload: {projectId: string, year: number, month:number}): Promise<Array<types.ProjectReportByProject>> {
      const { rootState, commit } = moduleActionContext(context, ProjectReport)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<Array<types.ProjectReportByProject>>>('/api/projectreport/byproject/' + payload.year + '/' + payload.month + '/' + payload.projectId, "プロジェクトリストの取得に失敗しました", {}, rootState.Login.accessToken)
      var list = retval.data.data
      return list
    },
    async getProjectIssues(context, payload: {projectId: string, year: number, month:number}): Promise<Array<types.ProjectReportIssue>> {
      const { rootState, commit } = moduleActionContext(context, ProjectReport)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<Array<types.ProjectReportIssue>>>('/api/projectreport/issues/' + payload.year + '/' + payload.month + '/' + payload.projectId, "プロジェクトリストの取得に失敗しました", {}, rootState.Login.accessToken)
      var list = retval.data.data
      return list
    },
    async updateIssue(context, issue: types.ProjectReportIssue) {
      const { rootState, commit } = moduleActionContext(context, ProjectReport)
      type Response = Endpoints["GET /repos/{owner}/{repo}/issues/{issue_number}"]["response"];
      type Parameters = Endpoints["GET /repos/{owner}/{repo}/issues/{issue_number}"]["parameters"];
      let token = rootState.Login.userInfo.githubUserToken
      const octokit = new Octokit({auth:token})
      if (issue.issueNumber == null) {return;}
      let param:Parameters = {owner: issue.organzationName, repo: issue.repositoryName, issue_number: issue.issueNumber ?? 0}
      const response: Response = await octokit.request("GET /repos/{owner}/{repo}/issues/{issue_number}", param);
      var obj: types.ProjectReportIssueToUpdate = {
        projectRepositoryId: issue.projectRepositoryId ?? '',
        organzationName: issue.organzationName,
        repositoryName: issue.repositoryName,
        organizationId: issue.organizationId,
        repositoryId: issue.repositoryId,
        issueNumber: issue.issueNumber,
        issueName: response.data.title,
        milestoneGithubId: response.data.milestone?.id == null ? '' : response.data.milestone?.id,
        milestoneTitle: response.data.milestone?.title == null ? '' : response.data.milestone?.title
      }
      let values = Object.assign({}, obj) as unknown as {[key: string]: string;}
      const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/projectreport/updateissue', 'Issueの更新に失敗しました。', values, rootState.Login.accessToken)
    },
    /// <summary>
    /// GitHub Projects v2のカスタムフィールドからIssue→作番マッピングを取得する
    /// </summary>
    async fetchIssueWorkOrderMappings(context, issues: types.ProjectReportIssue[]): Promise<{issueNumber: number, workOrderSerialNumber: number}[]> {
      const { rootState } = moduleActionContext(context, ProjectReport)
      const token = rootState.Login.userInfo.githubUserToken
      const octokit = new Octokit({auth: token})
      const targetFieldNames = ['Work Order Number', '作番', 'WorkOrderNumber', 'WorkOrder#']
      const mappings: {issueNumber: number, workOrderSerialNumber: number}[] = []

      for (const issue of issues) {
        if (issue.issueNumber == null) continue
        try {
          const response: any = await octokit.graphql(`
            query($owner: String!, $repo: String!, $issueNumber: Int!) {
              repository(owner: $owner, name: $repo) {
                issue(number: $issueNumber) {
                  projectItems(first: 10) {
                    nodes {
                      fieldValues(first: 20) {
                        nodes {
                          ... on ProjectV2ItemFieldNumberValue {
                            number
                            field { ... on ProjectV2FieldCommon { name } }
                          }
                          ... on ProjectV2ItemFieldTextValue {
                            text
                            field { ... on ProjectV2FieldCommon { name } }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `, { owner: issue.organzationName, repo: issue.repositoryName, issueNumber: issue.issueNumber })

          const projectItems = response?.repository?.issue?.projectItems?.nodes ?? []
          for (const item of projectItems) {
            const fieldValues = item?.fieldValues?.nodes ?? []
            for (const fv of fieldValues) {
              if (fv?.field && targetFieldNames.includes(fv.field.name)) {
                let val: number | null = null
                if (typeof fv.number === 'number') { val = fv.number }
                else if (typeof fv.text === 'string') {
                  const parsed = parseInt(fv.text, 10)
                  if (!isNaN(parsed)) { val = parsed }
                }
                if (val !== null) {
                  mappings.push({ issueNumber: issue.issueNumber, workOrderSerialNumber: val })
                }
              }
            }
          }
        } catch (e) {
          console.warn(`Failed to fetch project fields for issue #${issue.issueNumber}:`, e)
        }
      }
      return mappings
    },
    /// <summary>
    /// Issue→作番マッピングをバックエンドに送信してWorkOrderNumberIdを更新する
    /// </summary>
    async updateWorkOrderFromIssues(context, payload: {projectId: string, mappings: {issueNumber: number, workOrderSerialNumber: number}[]}): Promise<number> {
      const { rootState } = moduleActionContext(context, ProjectReport)
      const retval = await Lib.Ajax.postHandleError<types.DataResponse<number>>(
        '/api/projectreport/updateworkorderfromissues',
        '作番のIssue連携に失敗しました。',
        { projectId: payload.projectId, mappingsJson: JSON.stringify(payload.mappings) },
        rootState.Login.accessToken
      )
      return retval.data.data
    }
  },
  namespaced: true
})

export default ProjectReport